<!-- Project General Information -->
<div class="hcol-flex gap-half">
    <!-- Left Column: Project Info + Editable Fields -->
    <div class="hcol-grow">
        <p-panel>
            <ng-template pTemplate="header">
                <div class="hcol-grow" style="display: flex; align-items: center; gap: 0.5rem">
                    <span class="p-panel-title">Project information</span>
                    @if (canEditProject) {
                        <p-button
                            size="small"
                            severity="secondary"
                            icon="pi pi-pencil"
                            (onClick)="openProjectEditModal()"
                            pTooltip="Edit Project"
                            tooltipPosition="bottom"
                        />
                    }
                </div>
            </ng-template>

            <div style="display: flex; flex-direction: column; height: calc(100vh - 20rem)">
                <div class="hcol-flex gap-half w-100 space-around-start">
                    <div class="info-col">
                        <div class="text-bold align-h">Name</div>
                    </div>
                    <div class="info-col" style="min-width: 20rem">
                        <div class="align-h w-100">
                            {{ project?.name ?? '--' }}
                        </div>
                    </div>
                    <div class="hcol-grow"></div>
                    <div class="align-h">
                        <i class="pi pi-user me-1"></i>
                        <span class="text-bold">Created by</span> {{ createdByUser?.email ?? '--' }}
                        <span class="text-bold">at</span> {{ project?.created_at | date: 'yyyy-MM-dd HH:mm' }}
                    </div>
                </div>

                <div class="w-100 mt-1" style="display: flex; flex-direction: column; flex-grow: 1; min-height: 0">
                    <div class="text-bold align-h mb-1">Description</div>
                    <div
                        class="p-3"
                        style="
                            border: 1px solid #dee2e6;
                            border-radius: 8px;
                            white-space: pre-wrap;
                            flex-grow: 1;
                            overflow-y: auto;
                        "
                    >
                        {{ project?.description || 'No description...' }}
                    </div>
                </div>
            </div>
        </p-panel>
    </div>

    <!-- Right Column: Overview Statistics -->
    <div [style.width]="'8rem'">
        <p-panel header="Overview" class="title-center">
            <div class="vcol-flex space-around-center">
                <div class="content-center">
                    <div class="content-center">
                        <span
                            pTooltip="Service Requests"
                            tooltipPosition="left"
                            class="pi pi-list"
                            [style.fontSize]="'2.5rem'"
                        ></span>
                        <div>{{ serviceRequestsCount ?? '--' }}</div>
                        <p class="mb-0">Service Requests</p>
                    </div>
                </div>

                <div class="content-center">
                    <div class="content-center">
                        <span
                            pTooltip="Files"
                            tooltipPosition="left"
                            class="pi pi-file"
                            [style.fontSize]="'2.5rem'"
                        ></span>
                        <div>{{ filesCount ?? '--' }}</div>
                        <p class="mb-0">Files</p>
                    </div>
                </div>

                <div class="content-center">
                    <div class="content-center">
                        <span
                            pTooltip="Object Store Entry"
                            tooltipPosition="left"
                            class="pi pi-database"
                            [style.fontSize]="'2.5rem'"
                        ></span>
                        <div>{{ objectStoreCount ?? '--' }}</div>
                        <p class="mb-0">Object Store Entry</p>
                    </div>
                </div>
            </div>
        </p-panel>
    </div>
</div>
